// Minimal, dependency-free CSV parser supporting quoted fields and escaped quotes.
export function parseCSV(text) {
  const rows = [];
  let row = [], field = "", inQuotes = false;
  for (let i = 0; i < text.length; i++) {
    const c = text[i], nx = text[i + 1];
    if (inQuotes) {
      if (c === '"' && nx === '"') { field += '"'; i++; }
      else if (c === '"') inQuotes = false;
      else field += c;
    } else {
      if (c === '"') inQuotes = true;
      else if (c === ",") { row.push(field); field = ""; }
      else if (c === "\n") { row.push(field); rows.push(row); row = []; field = ""; }
      else if (c === "\r") { /* skip */ }
      else field += c;
    }
  }
  if (field.length > 0 || row.length > 0) { row.push(field); rows.push(row); }
  const filtered = rows.filter((r) => r.some((v) => (v || "").trim() !== ""));
  if (filtered.length === 0) return { headers: [], data: [] };
  const headers = filtered[0].map((h) => h.trim());
  const data = filtered.slice(1).map((r) => {
    const obj = {};
    headers.forEach((h, idx) => (obj[h] = (r[idx] || "").trim()));
    return obj;
  });
  return { headers, data };
}

export const FIELDS = [
  { key: "date", label: "Date", required: true, hints: ["date", "year", "when", "time"] },
  { key: "title", label: "Title", required: true, hints: ["title", "name", "event", "heading"] },
  { key: "description", label: "Description", required: false, hints: ["description", "desc", "detail", "body", "summary", "notes"] },
  { key: "image", label: "Image URL", required: false, hints: ["image", "img", "photo", "picture"] },
  { key: "category", label: "Category", required: false, hints: ["category", "type", "group", "section"] },
  { key: "url", label: "Link", required: false, hints: ["url", "link", "source", "href"] },
];

export function autoMap(headers) {
  const map = {};
  FIELDS.forEach((f) => {
    const found = headers.find((h) => f.hints.some((hint) => h.toLowerCase().includes(hint)));
    if (found) map[f.key] = found;
  });
  return map;
}
